export const SET_GRID_INSTANCE = 'grid/SET_GRID_INSTANCE';
export const setGridInstance = gridInstance => ({
  type: SET_GRID_INSTANCE,
  gridInstance
});

export const SET_GRID_ID_NAME = 'grid/SET_GRID_ID_NAME';
export const setGridIdName = gridStateName => ({
  type: SET_GRID_ID_NAME,
  gridStateName
});
